module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/additional-briefing-elite-50.02ec0fcf.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/additional-briefing-elite-50.png
// module id = 3690
// module chunks = 11